<template>
  <div class>
    <div class="login">
      <form class="form-signin login__form">
        <img class="mb-4 login__form--img" src="@/assets/image/logo.png" alt />
        <label for="inputEmail" class="sr-only">Email address</label>
        <input
          type="email"
          id="inputEmail"
          class="form-control"
          placeholder="Email address"
          required
          autofocus
          v-model="user.email"
        />
        <label for="inputPassword" class="sr-only">Password</label>
        <input
          type="password"
          id="inputPassword"
          class="form-control"
          placeholder="Password"
          required
          v-model="user.password"
        />
        <label for="confirmPassword" class="sr-only">Confirm Password</label>
        <input
          type="password"
          id="confirmPassword"
          class="form-control"
          placeholder="Confirm Password"
          required
          v-model="user.confirm_password"
        />
        <p class="login__form--error">{{error}}</p>
        <!-- <div class="checkbox mb-4">
        </div>-->
        <button class="btn btn-lg btn-primary btn-block" type="submit" @click.prevent="ceate_account()">
          Submit
          <i class="fas fa-sign-in-alt"></i>
        </button>
      </form>
    </div>
  </div>
</template>
<script>
import client from '@/api/client'
export default {
  data() {
    return {
      user: {
        email: '',
        password: '',
        confirm_password: '',
      },
      error: '',
    };
  },
  methods: {
    ceate_account() {
      const vm = this;
      if (!vm.user.email.includes('@')) {
        vm.error = '無效的email格式';
      } else if (vm.user.email === '' || vm.user.password === '') {
        vm.error = '帳號密碼不得留空';
      } else if (vm.user.password !== vm.user.confirm_password) {
          vm.error = '密碼不一致';
      } else {
        console.log('do register');
        let user = {
          email: vm.user.email,
          password: vm.user.password,
          role: 'labeller',
          scope:[]
        }
        client.post('/account', null, user).then((resp) => {
          if (resp.results === 'success') {
              vm.$store.dispatch('Login', {email:user.email, password:user.password}).then((response) => {
                if (response.token) {
                  vm.$store.dispatch('GetProfile', {token:response.token}).then((response) => {
                    vm.$router.push('/task');
                  });
                }
            });
          }
        })
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
